<div>
    <div class="breadcrumb-block">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a href="#">Home</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                    Manage Hotel
                </li>
            </ol>
        </nav>
    </div>
    <div class="manage-package-block">
        <div class="white-box">
            <div class="table-title">
                <div class="container-fluid px-0">
                    <div class="row">
                        <div class="col-lg-12" v-if="getHotelTitle">
                            <h5 v-if="getHotelTitle.title">{{ getHotelTitle.title}}</h5>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Tabs -->
            <div class="tabs-block">
                <div class="top-tab">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" @click="redirectToGeneral">
                            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#general" role="tab" aria-controls="home" aria-selected="true"><i class="fas fa-align-justify"></i>
                General</a>
                        </li>
                        <li class="nav-item" @click="redirectToFaq">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" href="#faq" role="tab" aria-controls="contact" aria-selected="false"><i class="fas fa-question-circle"></i>
                FAQ</a>
                        </li>
                        <li class="nav-item" @click="redirectToHotelAmenity">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" href="#hotelAmenity" role="tab" aria-controls="contact" aria-selected="false"><i class="fas fa-bed"></i>
                Hotel Amenity</a>
                        </li>
                        <li class="nav-item" @click="redirectToHotelGallery">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" href="#hotelGallery" role="tab" aria-controls="contact" aria-selected="false"><i class="fas fa-image"></i>
                Gallery</a>
                        </li>

                        <li class="nav-item" @click="redirectToHotelRoom">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" href="#room" role="tab" aria-controlUpcommingDepRooartures="contact" aria-selected="false"><i class="fas fa-shower"></i>
                      Room Management</a>
                        </li>

                        <li class="nav-item" @click="redirectToHotelPaymentMethod">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" href="#hotelPaymentMethod" role="tab" aria-controls="contact" aria-selected="false"><i class="fas fa-credit-card"></i>
                      Payment Method
                  </a>
                        </li>
                        <!-- 
                        
                      
                        -->
                        <!-- 
            
            -->
                        <!-- <li class="nav-item" @click="redirectToUpcommingDeparture">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" href="#booking" role="tab" aria-controls="contact" aria-selected="false"><i class="fas fa-check-double"></i>
                Upcoming Departure</a>
                        </li>
                        <li class="nav-item" @click="redirectToBooking">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" href="#booking" role="tab" aria-controls="contact" aria-selected="false"><i class="fas fa-check-double"></i>
                Booking</a>
                        </li> -->

                        <!-- <li class="nav-item" @click="redirectToGalleryPreBooking">
                  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#prebooking" role="tab"
                      aria-controls="contact" aria-selected="false"><i class="fas fa-check"></i>
                      Pre-booking</a>
              </li> -->
                        <!-- <li class="nav-item" @click="redirectToOfferService">
                  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#offerservice" role="tab"
                      aria-controls="contact" aria-selected="false"><i class="fas fa-check"></i>
                      Offer/ Services</a>
              </li> -->
                        <!-- <li class="nav-item" @click="redirectToReviews">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" href="#reviews" role="tab" aria-controls="contact" aria-selected="false"><i class="fas fa-user"></i>
                Reviews</a>
                        </li> -->
                    </ul>
                </div>
                <router-view></router-view>
            </div>
        </div>
    </div>


</div>